import { useQuery } from '@tanstack/react-query';

import { FAQPage } from '../../copied/models/ChatModules';
import fetchCategoryResults from '../../services/categories';
import useFetchHelpCenter from './useFetchHelpCenter';

export default function useFetchCategoryResults(category: string) {
  const { data } = useFetchHelpCenter();

  const uuid = data?.uuid;

  return useQuery<FAQPage[]>({
    queryKey: ['search', uuid, category],
    queryFn: () => fetchCategoryResults(uuid!, category),
    enabled: !!uuid,
  });
}
